var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.3 40.1C76.3 20.2 60.2 4.09998 40.3 4.09998C20.4 4.09998 4.3 20.2 4.3 40.1C4.3 60 20.4 76.1 40.3 76.1C60.2 76.1 76.3 60 76.3 40.1ZM7.6 40.1C7.6 22 22.3 7.39998 40.3 7.39998C58.3 7.39998 73 22.1 73 40.1C73 58.1 58.4 72.8 40.3 72.8C22.2 72.8 7.6 58.2 7.6 40.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4 39.3L31.4 19.3C31.1 19.1 30.7 19.1 30.4 19.2C30.1 19.4 29.9 19.7 29.9 20.1V60.1C29.9 60.5 30.1 60.8 30.4 61C30.5 61.1 30.7 61.1 30.9 61.1C31.1 61.1 31.3 61 31.5 60.9L60.5 40.9C60.8 40.7 60.9 40.4 60.9 40.1C60.8 39.8 60.6 39.5 60.4 39.3Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterYoutube);
export default __webpack_public_path__ + "static/media/footer-youtube.c2b5d8a6.svg";
export { ForwardRef as ReactComponent };